<template>
  <div class="w-full lg:flex lg:flex-col whitespace-no-wrap pt-12 text-main-text">
    <stats-file-catch-modal key="stats_file_catch"
                            :catch_file_text="catch_file_text"
                            v-if="stats_file_catch" @close="stats_file_catch = false"
                            class="z-50 flex"/>
    <div class="w-full overflow-x-auto overflow-y-hidden">
      <table class="w-full h-full relative">
        <thead>
        <tr class="md:border-b">
          <th class="invisible "></th>
          <th class="text-10px md:text-sm">№</th>
          <th class="text-10px md:text-sm w-48 md:w-1/2 text-10px md:text-sm text-left">Название команды</th>
          <th class="text-10px md:text-sm w-64" v-if="event.results_filled"><p class="">Балл</p></th>
          <th class="text-10px md:text-sm w-64" v-if="event.works_with_privileged">Льготная</th>
          <th class="text-10px md:text-sm w-64"><p class="">К оплате</p></th>
          <th class="text-10px md:text-sm w-64"><p class="">Заявлено игроков</p></th>
          <th class="text-10px md:text-sm pl-1 w-64  relative" colspan="2"><p class="mb-8">Кол-во игроков</p>
            <span class="text-10px md:text-sm font-normal absolute pin-b pin-l mb-2 w-1/2">платные</span>
            <span class="text-10px md:text-sm font-normal absolute pin-b pin-r mb-2 w-1/2">беспл.</span>
          </th>
          <th class="w-24 text-10px md:text-sm">% Скидки</th>
          <th class="w-64"></th>
          <th class="hide-element w-64 hide-element"></th>
        </tr>
        </thead>
        <tbody>
        <stat-list-data-line
            v-for="(registration_line, key) in stat_data"
            :registration="registration_line"
            :key="key"
            :game-type="event.game_type"
            :product="event.product"
            :works-with-privileged="event.works_with_privileged"
            :team_count="key"
            :event="event"
            :city="cityObj"
            @player_count_change="submit_total($event)"
        />
        </tbody>
      </table>
    </div>

    <modal :application_adding="true" :max_width="775" class="overlay" v-if="newComand" :click-outside="false">
      <new-registration-modal
          :opened_from="'stat-list'"
          :event_price="event.price"
          :eventId="event.uuid"
          @close="newComand = false"
          @saved="newComand = false; $emit('update')"
      ></new-registration-modal>
    </modal>
    <div v-if="event.is_registration_opened && event.works_with_results === true"
         class="w-full md:flex justify-start pt-10 md:pl-8 pl-1  mx-4 lg:mx-0 xl:mx-0">
      <div @click="createTeam" class="flex flex-row items-center w-48 cursor-pointer">
        <div class="rounded-full flex flex-row justify-center items-center w-8 h-8
                outline-none bg-additional-text">
          <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']"></font-awesome-icon>
        </div>
        <p class="ml-3 text-10px md:text-sm font-bold text-additional-text">Добавить команду</p>
      </div>
    </div>

    <div class="mt-5 px-4 w-full md:w-auto md:justify-between md:items-center flex-col md:flex-row lg:mx-0 xl:mx-0">
      <div class="flex flex-col font-bold justify-end md:mr-3">
        <!--        desktop -->
        <div class="w-full mb-4 hidden md:flex justify-end">
          <p class="w-40 text-right pr-2">Итого платных:</p>
          <p class="font-normal w-20">{{ totalPayable || 0 }} игроков </p>
        </div>
        <div class="w-full mb-4 hidden md:flex justify-end">
          <p class="w-40 text-right pr-2">Итого бесплатных:</p>
          <p class="font-normal w-20">{{ totalFree || 0 }} игроков </p>
        </div>
        <div class="w-full mb-4 hidden md:flex justify-end">
          <p class="w-40 text-right pr-2">Общее количество:</p>
          <p class="font-normal w-20">{{ total || 0 }} игроков </p>
        </div>
        <div class="w-full mb-4 hidden md:flex justify-end">
          <p class="w-40 text-right pr-2">Выручка:</p>
          <p class="font-bold text-brand-light w-20">{{ getTotalCost.toLocaleString('ru-RU') || 0 }}<span class="ml-1">{{ currencySign }}</span>
          </p>
        </div>


        <!--        mobile    -->
        <div class="md:hidden">
          <div class="text-10px flex justify-end mb-1">
            <p class="w-30 mr-1">Итого платных:</p>
            <span class="font-normal w-16">{{ totalPayable || 0 }} Игроков</span>
          </div>

          <div class="text-10px flex justify-end mb-1">
            <p class="w-30 mr-1">Итого бесплатных:</p>
            <span class="font-normal w-16">{{ totalFree || 0 }} Игроков</span>
          </div>

          <div class="text-10px flex justify-end mb-1">
            <p class="w-30 mr-1">Общее количество:</p>
            <span class="font-normal w-16">{{ total || 0 }} Игроков</span>
          </div>

          <div class="text-10px flex justify-end">
            <p class="w-30 mr-1">Выручка:</p>
            <span class="text-brand-light w-16">{{ getTotalCost.toLocaleString('ru-RU') || 0 }}{{ currencySign }}</span>
          </div>

        </div>

        <div class="w-full flex flex-col md:flex-row">
          <p v-if="showDescription" class="font-normal text-mxs text-brand-light mt-auto hidden md:inline">
            *В данной строке можно вписать общее число игроков,<br> которые не зарегистрировались, но сыграли в эту игру.<br> Если таких игроков не было, поставьте 0.
          </p>
          <div class="w-full flex justify-end flex-col lg:flex-row xl:flex-row">
            <div v-if="event.works_with_results === true && !event.results_filled && this.user.role !== 'event_organizer'"
                 class="flex justify-center relative rounded-full w-full lg:w-button-stats py-3 mt-3
                     cursor-pointer mr-2 bg-white font-semibold text-main-text">
              <div class="flex items-center cursor-pointer">
                <img src="@/assets/SVG/uploadResultsIcon.svg" alt="uploadResultsIcon" class="mr-2">
                <input ref="file" class="absolute pin opacity-0 cursor-pointer w-full lg:w-button-stats"
                       @change="load_results" type="file" accept="exel/*">
                <p class="text-xm cursor-pointer font-normal">Загрузить результаты</p>
              </div>
            </div>
            <div v-if="event.results_filled"
                 class="items-center flex mt-3 w-full justify-start lg:justify-end xl:justify-end mr-8 w-full lg:w-button-stats xl:w-button-stats">
              <div class="flex flex-row w-full justify-center md:justify-end">
                <div class="truncate whitespace-no-wrap rounded max-w-2xxs cursor-pointer"
                     @mousedown="overflowTumbler" @mouseup="overflowTumbler" @mouseout="endOverflow" field="canAbs">
                  <!--                <p class="p-1">{{mediaResultsSplit}}</p>-->
                  <span>{{ mediaResultsSplit }}</span>
                </div>
                <button class="outline-none ml-2" @click.prevent="deleteMediaResults">
                  <img class="h-4" src="@/assets/SVG/cross-partners.svg" alt="cross-partner"/>
                </button>
              </div>
            </div>
            <button @click="sendStatisticsModal = true"
                    v-if="showSendStatButton"
                    :disabled="isSendStatBtnDisabled"
                    :class="[isSendStatBtnDisabled ?'bg-menuOrder-gray-light text-white cursor-default':'hover:border-brand-light hover:bg-brand-light hover:text-white bg-white']"
                    class=" outline-none font-semibold rounded-full text-main-text border-2 border-menuOrder-gray-light
              w-full lg:w-button-stats xl:w-button-stats
               mt-3 py-3 -mb-0 md:mr-8 mb-4"
            >Отправить статистику
            </button>
            <button @click="send_to_main"
                    class=" outline-none bg-white font-semibold rounded-full text-main-text border-2 border-menuOrder-gray-light
            hover:border-brand-light hover:bg-brand-light w-full lg:w-button-stats xl:w-button-stats hover:text-white mt-3 py-3 -mb-0 md:mr-3 mb-4"
            >Сохранить
            </button>
          </div>
        </div>

      </div>
    </div>

    <sendStatisticRating
        key="sendStatisticsModalSingle"
        v-if="sendStatisticsModal"
        @close="sendStatisticsModal = false"
        @white_button="sendStatisticsModal = false"
        @yellow_button="send_stat"
        :text="'Вы точно хотите отправить данные?'"
        :button_text_firs="'Отменить'"
        :button_text_second="'Отправить'"
        class="z-50 flex"
        modalClasses="max-w-105"
        textClasses="px-12"
    />
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import client from '@/clients/partners';
import Modal from '@/views/modals/base-modal.vue';
import NewRegistrationModal from '@/views/partners/current-registration/registration-layout/new-registration-modal.vue';
import StatsFileCatchModal
  from '@/views/partners/current-registration/stat-layout/stat-modal/stats-file-catch-modal.vue';
import sendStatisticRating from '@/views/partners/data-base/confirm-delete.vue';
import FilterTeams from '../../data-base/filter-teams.vue';
import statListDataLine from './filial-stat-list-data-line.vue';

export default {
  name: 'filial-stat-list-data',
  components: {
    StatsFileCatchModal,
    NewRegistrationModal,
    statListDataLine,
    FilterTeams,
    Modal,
    sendStatisticRating,
  },
  props: {
    registration_date: {
      type: Array,
    },
    event: {
      type: Object,
    },
    number_of_events: {
      type: Number,
    },
  },
  data() {
    return {
      stat_data: [],
      applications: [],
      newComand: false,
      stats_file_catch: false,
      catch_file_text: false,
      spinner: false,
      showDescription: false,
      sendStatisticsModal: false,
      discount: 0,
    };
  },
  mounted() {
    if (this.registration_date) this.check_curr_applications();
    this.updateShowDescription();
  },
  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    submit_total(line) {
      Object.keys(this.stat_data).forEach((item) => {
        if (this.stat_data[item].id === line.id) {
          this.stat_data[item].actual_player_count = line.actual_player_count;
          this.stat_data[item].actual_free_player_count = line.actual_free_player_count;
          this.stat_data[item].actual_payable_player_count = line.actual_payable_player_count;
          this.stat_data[item].unaccounted_team_count = line.unaccounted_team_count;
          this.stat_data[item].is_privileged = line.is_privileged;
          this.stat_data[item].discount = line.discount;
        }
      });
      if (this.applications.length) {
        const idx = this.applications.findIndex(item => item.id === line.id);

        if (idx > -1) {
          if (this.applications[idx].id && (!line.actual_player_count && line.actual_player_count !== 0)) {
            this.applications.splice(idx, 1);
            return;
          }
          if (line.actual_player_count || line.actual_player_count === 0) {
            this.applications[idx].actual_player_count = line.actual_player_count;
            this.applications[idx].actual_free_player_count = line.actual_free_player_count ? line.actual_free_player_count : 0;
            this.applications[idx].actual_payable_player_count = line.actual_payable_player_count ||
            line.actual_payable_player_count === 0 || line.actual_payable_player_count === '0' ?
                line.actual_payable_player_count : line.actual_player_count;
            this.applications[idx].unaccounted_team_count = line.unaccounted_team_count;
            this.applications[idx].is_privileged = line.is_privileged;
            this.applications[idx].discount = line.discount ? line.discount : 0;
            // this.applications[idx].results_filled = this.event.results_filled;
            // this.applications[idx].works_with_results = this.event.works_with_results;
          }
        } else {
          this.applications.push(line);
        }
      } else {
        this.applications.push(line);
      }
      if (this.applications.length === this.stat_data.length) {
        this.$emit('list_total', this.applications);
      }
    },
    send_to_main() {
      if (!this.applications.length) {
        this.stat_data.forEach((item) => {
          if (item.actual_player_count || item.actual_player_count === 0) {
            this.applications.push({
              id: item.id,
              actual_player_count: item.actual_player_count,
              actual_free_player_count: item.actual_free_player_count,
              actual_payable_player_count: item.actual_payable_player_count,
              unaccounted_team_count: item.unaccounted_team_count,
              is_privileged: item.is_privileged,
              discount: item.discount,
            });
          }
        });
      }
      client
          .patch(`applications/dates/${this.event.uuid}/statistic`, {
            applications: this.applications,
          })
          .then(() => {
            this.selectModalText('Изменения сохранены');
            this.selectShowModal(true);
            this.$emit('list_total', this.applications);
          })
          .catch((err) => {
            const errorText = err.response.data.errors.applications[0];
            this.selectModalText(errorText);
            this.selectShowModal(true);
          });
    },
    load_results(e) {
      const file = e.target.files[0];
      const data = new FormData();
      data.append('results', file);
      data.append('event_day_id', this.event.uuid);
      this.$emit('loading_results', true);
      client.post('results', data)
          .then(() => {
            this.$emit('update');
            this.$emit('loading_results', false);
            this.$refs.file.value = '';
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.data.errors.results) {
                this.catch_file_text = error.response.data.errors.results[0];
              }
              if (error.response.data.errors.playApplication) {
                this.catch_file_text = error.response.data.errors.playApplication[0];
              }
              if (error.response.data.errors.fileParsing) {
                this.catch_file_text = error.response.data.errors.fileParsing[0];
              }
              if (error.response.data.errors.processing) {
                this.catch_file_text = error.response.data.errors.processing[0];
              }
            }
            this.stats_file_catch = true;
            this.$emit('loading_results', false);
            this.$refs.file.value = '';
          });
    },
    check_curr_applications() {
      this.registration_date.forEach(item => this.stat_data.push(item));
      this.overfillApplications(this.registration_date);
    },
    overfillApplications(filler) {
      Object.keys(filler).forEach((item) => {
        if (filler[item].actual_player_count || filler[item].actual_player_count === 0) {
          this.applications.push({
            actual_player_count: filler[item].actual_player_count,
            actual_free_player_count: filler[item].actual_free_player_count,
            actual_payable_player_count: filler[item].actual_payable_player_count,
            unaccounted_team_count: filler[item].unaccounted_team_count,
            is_privileged: filler[item].is_privileged,
            id: filler[item].id,
            discount: filler[item].discount,
          });
        }
      });
      if (this.applications.length === this.stat_data.length) {
        this.$emit('list_total', this.applications);
      }
    },
    createTeam() {
      if (this.mobile) {
        this.$router.push({
          name: 'new-team-mobile',
          params: {
            isCorpLeague: this.isCorpLeague,
            eventId: this.event.uuid,
            price: this.event.price,
            opened_from: 'stat-list',
          },
        });
      } else {
        this.newComand = true;
      }
    },
    deleteMediaResults() {
      this.spinner = true;
      this.$emit('loading_results', true);
      client.delete('results', {data: {event_day_id: this.event.uuid}})
          .then(() => {
            this.$emit('update');
            this.$emit('loading_results', false);
          });
    },
    updatePageData() {
      client.get('event-dates?');
    },
    overflowTumbler(event) {
      const target = event.target.parentElement;
      const isOverflow = target.scrollWidth > target.clientWidth;
      if (target.getAttribute('field') === 'canAbs' && (isOverflow || target.classList.contains('exp'))) {
        if ((event.type === 'mouseup') && isOverflow) return;
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    endOverflow(event) {
      const target = event.target.parentElement;
      if (target.getAttribute('field') === 'canAbs' && (target.classList.contains('exp'))) {
        target.classList.toggle('truncate');
        target.classList.toggle('absolute');
        target.classList.toggle('border');
        target.classList.toggle('bg-white');
        target.classList.toggle('fit_content');
        target.classList.toggle('exp');
      }
    },
    updateShowDescription() {
      this.registration_date.forEach((item) => {
        if (!item.team) {
          this.showDescription = true;
        }
      });
    },
    send_stat() {
      client
          .patch(`applications/dates/${this.event.uuid}/statistic/partial`, {
            applications: this.applications,
          })
          .then(() => {
            this.$emit('update');
          })
          .catch(() => {
            this.$emit('reject');
          });
    },
  },
  computed: {
    ...mapState({
      cityObj: state => state.auth.user.cityObj,
      user: state => state.auth.user,
      currency: state => state.auth.user.currency,
    }),
    mobile() {
      return window.innerWidth < 840;
    },
    rotateArrow() {
      return !this.show_deleted_teams ? '' : 'rotate-arrow';
    },
    total() {
      let totalCount = 0;
      Object.keys(this.stat_data).forEach((item) => {
        totalCount += +this.stat_data[item].actual_player_count;
      });
      return totalCount;
    },
    totalFree() {
      let totalCount = 0;
      Object.keys(this.stat_data).forEach((item) => {
        totalCount += +this.stat_data[item].actual_free_player_count;
      });
      return totalCount;
    },
    totalPayable() {
      let totalCount = 0;
      Object.keys(this.stat_data).forEach((item) => {
        totalCount += +this.stat_data[item].actual_payable_player_count;
      });
      return totalCount;
    },
    getTotalCost() {
      let total = 0;
      this.stat_data.forEach((item) => {
        if (item.player_count && !item.actual_payable_player_count && item.actual_payable_player_count !== 0) {
          let totalWithoutDiscount = 0;
          totalWithoutDiscount = (item.player_count * (this.event.price / 100));
          total += totalWithoutDiscount - (totalWithoutDiscount * (item.discount / 100));
        } else {
          let totalWithoutDiscount = 0;
          totalWithoutDiscount = (item.actual_payable_player_count * (this.event.price / 100));
          total += totalWithoutDiscount - (totalWithoutDiscount * (item.discount / 100));
        }
      });
      return total;
    },
    mediaResultsSplit() {
      if (this.event.media_results !== [] && this.event.media_results.results) {
        const result_splited_line = this.event.media_results.results.split('/');
        console.log(result_splited_line, 'result_splited_line');
        if (result_splited_line[result_splited_line.length - 1]) {
          const result = result_splited_line[result_splited_line.length - 1].split('.')[0];
          console.log(result, 'result');
          return decodeURI(result);
        }
        return null;
      }
      return null;
    },
    isSendStatBtnDisabled() {
      return this.stat_data.length !== this.applications.length || this.applications.length === 0 || !this.allResultsFilled;
    },
    allResultsFilled() {
      if (!this.event.works_with_results) {
        return true;
      }
      return this.event.results_filled;
    },
    showSendStatButton() {
      return this.number_of_events > 1 || (this.number_of_events === 1 && this.event.hasOtherUnplayedEventDays);
    },
    currencySign() {
      return this.currency === 'RUB' ? '₽' : '';
    },
  },
  watch: {
    registration_date() {
      this.check_curr_applications();
      this.updateShowDescription();
    },
  },
};
</script>

<style scoped>
th {
  @apply text-center whitespace-no-wrap px-2 bg-white font-sans text-sm;
  vertical-align: top;
}

td {
  @apply text-center p-2 font-sans text-sm;
}


.arrow {
  transition: 0.5s all;
}

.rotate-arrow {
  transform: rotate(180deg);
}

.copy-icon-class {
  width: 2.24rem;
  height: 2.2rem;
  border-radius: 100%;
  background-color: #e7e7e7;
}

@media (max-width: 767px) {
  .hide-element {
    display: none !important;
  }

  .w-56 {
    width: 14rem
  }
}

.fit_content {
  max-width: fit-content !important;
}
</style>
